import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-error-popup',
  templateUrl: './errorpopup.component.html',
  styleUrls: ['./errorpopup.component.css'],
})
export class ErrorPopupComponent {
  @Input() message: string
  isVisible = false

  show(message: string) {
    this.message = message
    this.isVisible = true
  }

  close() {
    this.isVisible = false
  }
}
